// extracted by mini-css-extract-plugin
module.exports = {"result":"styles_result__2xUux","mark":"styles_mark__2sl0k","blue":"styles_blue__3skQW","yellow":"styles_yellow__9jjHM","buttons":"styles_buttons__JfNJ5"};